
toll['mapkit'] = (function() {
    
    var LOADING = null;
    var INITIALIZING = null;
    var INITIALIZED = null;
    var CALLBACKS = [];



    var fireCallbacks = function() {
        
        for (var i = 0; i < CALLBACKS.length; i++) {
            CALLBACKS[i]();
        }
        
        CALLBACKS = [];
        
    };
    
    
    
    var initMapkit = function() {
        
        if (INITIALIZING) return;
        
        INITIALIZING = true;
        
        mapkit.init({
            // If you plan to use this code please use your own JWT key
            authorizationCallback: function(done) {
                  var date = new Date().getTime();
                  var callback = 'toll' + Math.floor(Math.random()*1000001);
                  var script = document.createElement('script');
                  script.type = 'text/javascript';
                  script.src = 'https://www.tollbrothers.com/api/mapkitToken?cachebuster=' + date + '&callback=' + callback;
  
                  window[callback] = function(data) {
                      done(data.token);
                  };
  
                  document.getElementsByTagName('head')[0].appendChild(script);
            },
            language: "en"
        });
        
        mapkit.addEventListener("configuration-change", function(event) {
            switch (event.status) {
            case "Initialized":
                INITIALIZED = true;
                fireCallbacks();
                break;
            }
        });
        
    };
    
    
    
    var waitForMapkit = function() {
        
        if (typeof mapkit === 'object' && typeof mapkit.init === 'function') {
            initMapkit();
        } 
        else {
            setTimeout(function() {
                waitForMapkit();
            }, 200);
        }
        
    };
    
    
    
    var loadMapkit = function(callback) {

        var url = 'https://cdn.apple-mapkit.com/mk/5.29.0/mapkit.js'; // 'https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js';

        if (callback) CALLBACKS.push(callback);

        if (typeof mapkit !== 'object' && !LOADING) {
            LOADING = true;
            var class_name = 'js-mapkit-maps-api';
            $('.' + class_name).remove();

            var script = document.createElement("script");
            script.src = url;
            script.type = "text/javascript";
            script.className = class_name;
            document.body.appendChild(script);
        }

        if (!INITIALIZED) {
            waitForMapkit();
        }
        else {
            fireCallbacks();
        }
    };

    return {
        load : loadMapkit
    };
    
})();




var neighborhoodLocations;
var MAP;

$(function() {

	if ( $('#map').length ) {
		communityMapSetup();
	}

	// POI Hover
	// ----------------------------------
	
	$(document).on('mouseenter', '.js-poi', function(e) {
		//var id = parseInt($(this).index()+1);
            var id = parseInt($(this).attr('data-id'));
		//console.log(id);
		if ( id <= MAP.annotations.length ) {
			closeInfoWindow();
			var marker = MAP.annotations[id];
			marker.selected = true;
		}
		//toll.map.centerMapToMarker(id);
		//toll.map.showInfoWindow(id);
	});
	


	$(document).on('click', '.js-closeInfoWindow', function(e) {
		e.preventDefault();
		closeInfoWindow();
		$('.community-listing').removeClass('highlight');
	});
		

	// POI Click
	// ----------------------------------
	$(document).on('click', '.js-poiCategory', function(e) {
		e.preventDefault();
		var category = $(this).attr('data-category');
		setPOICategory(category);
	});


	// Map Mobile Filter Panel
	// ----------------------------------
	$(document).on('click', '.js-toggleSearchFilter', function(e) {
		e.preventDefault();
		var $container = $('.site-wrapper');
		if ( $container.hasClass('open-filter-panel') ) {
			$container.removeClass('open-filter-panel');
		} else {
			$container.addClass('open-filter-panel');
		}
	});
	

	// Map POI Toggle
	// ----------------------------------
	$(document).on('click', '.js-togglePoiNav', function(e) {
		e.preventDefault();
		var $container = $('.area-map');
		if ( $container.hasClass('collapse') ) {
			$container.removeClass('collapse');
		} else {
			$container.addClass('collapse');
		}
	});

});

function getMarker(marker) {
	var offset = 20;

	var options;

	if ( marker.alwaysVisible ) {
		options = {
			title: '',
			data: marker,
	        url: { 
	            2: '/images/map-pin.png',
	        },
	        anchorOffset: new DOMPoint(0, 0)
	    };
	    return new mapkit.ImageAnnotation(new mapkit.Coordinate(Number(marker.latlong[0]), Number(marker.latlong[1])), options);
	} else {
		options = {
	        title: '',
	        data: marker,
	        callout: {
	            calloutElementForAnnotation: getMarkerInfoWindow,
	            calloutAnchorOffsetForAnnotation: function(marker, size) {    
	            	if ( marker.data.category ) {
	            		return new DOMPoint(-8, -20);
	            	} else {
	            		return new DOMPoint(-8, 8);
	            	}
	            }
	        }	        
	    };

	    return new mapkit.Annotation(new mapkit.Coordinate(Number(marker.latlong[0]), Number(marker.latlong[1])), factory, options);
	}
}

function getMarkerInfoWindow(marker) {
	return $(marker.data.windowHTML)[0];
}

function factory(coordinate, options) {
    var div = document.createElement("div");
    div.innerHTML = '<span>' + options.data.label + '</span>';
    div.className = "map-bubble";
    div.setAttribute('data-markerIndex',options.data.index);
    return div;
};

function closeInfoWindow() {
	if (!MAP) return;

    var selected_marker = MAP.selectedAnnotation;

    if (selected_marker) {
        selected_marker.selected = false; //close info window
    } 

    $('.js-map-tool-tip').remove();
}

function communityMapSetup() {

	// Grab all the loations
	// ------------------------------
	neighborhoodLocations = [{ 
        alwaysVisible: true,
        name:       "Sterling Grove",
        latlong:    [33.5929, -112.4289],        
        icon:       '/images/map-pin.png',
        iconWidth:  67,
        iconHeight: 79
	}];
	$(document).find('.category').each(function() {
		var category = $(this).attr('data-category');
		var count = 1;
		$(this).find('.category-list li').each(function() {
			var name = $(this).attr('data-name');
			var latlong = $(this).attr('data-latlong');

			neighborhoodLocations.push({
				name : name,
				latlong : latlong.split(','),
				label : true,
				label : count,
				index : count,
				category : category,
				windowHTML : '<div class="toll-map-infowindow js-map-window"><div class="inner-window"><div><button class="js-closeInfoWindow" title="Close Info Window">X</button><span class="headline">'+name+'</span></div></div></div>',
        		onclick:    function(d) { toll.map.showInfoWindow(d); toll.map.centerMapToMarker(d); }
			});

			count++;
		});
	});

	//console.log(neighborhoodLocations);

	toll.mapkit.load(function() {
	    // Center map on USA
	    var span = new mapkit.CoordinateSpan(35, 35);
	    var center = new mapkit.Coordinate(38.1000, -95.6250);
	    var region = new mapkit.CoordinateRegion(center, span);

	    MAP = new mapkit.Map(document.getElementById('map'), {
	        region: region,
	        showsUserLocationControl: false,
	        showsCompass: mapkit.FeatureVisibility.Hidden,
	        showsMapTypeControl: false
	    });

	    setPOICategory();
	});
}



function setPOICategory( category ) {
	// Clear old markers...
	if ( MAP ) {
		MAP.removeAnnotations(MAP.annotations);
	}

	if ( typeof category === 'undefined') {
		category = $(document).find('.category').eq(0).attr('data-category');
	}

	$('.category.on').find('.category-list').stop(true,true).slideUp(200);
      if ($(window).width() < 700) {
            $('.category.on').find('.category-list').hide();
      }
	$('.category.on').removeClass('on');
	
	$(document).find('.category').each(function() {
		if ( $(this).attr('data-category') == category ) {
			$(this).addClass('on');
			$(this).find('.category-list').stop(true,true).slideDown(200);
		}
	});

	var markers = [];

	// Add community marker
	markers.push( getMarker(neighborhoodLocations[0]) );

	// Add category markers
	for ( var i = 1; i < neighborhoodLocations.length; i++ ) {
		if ( neighborhoodLocations[i].category === category ) {
			markers.push( getMarker(neighborhoodLocations[i]) ); // getMarker() from search-page.js
		}
	}

	MAP.showItems(markers,
    	{ 
        	animate: true,
        	padding: new mapkit.Padding(60,60,60,60)
    	}
	); 

	MAP.annotationForCluster = function(clusterAnnotation) {
        var options = {
            title: '',
            size: {
                width: 50,
                height: 50
            },
            data: clusterAnnotation.memberAnnotations,
            calloutEnabled: false
        };

        var cluster = new mapkit.Annotation(clusterAnnotation.coordinate, clusterFactory, options);

        return cluster;

    };

    if ( markers.length === 1 ) {
    	MAP.setCameraDistanceAnimated(4500, false);
    }

}